import { render, staticRenderFns } from "./SchoolListsBusinessIndex.vue?vue&type=template&id=3c849254"
import script from "./SchoolListsBusinessIndex.vue?vue&type=script&lang=js"
export * from "./SchoolListsBusinessIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports